// Used for smart imports of templates

const SMART_VALUES = {
  MANUFACTURER: null,
  DEVICENAME: null,
  TEMPLATENAME: null,
  CATEGORIES: {
    NO: 'Normal',
    MA: 'Magic',
    AI: 'Air',
    BO: 'Body',
  },
  OPTIONS: {
    EI: 'Easy Install',
    CO: 'Cut Only',
    H: 'Hidden',
  },
};

const CATEGORIES = {
  typenormal: 'Normal',
  typemagic: 'Magic',
  typeair: 'Air',
  typebody: 'Body',
};
const OPTIONS = {
  easyinstall: 'Easy Install',
  cutonly: 'Cut Only',
  hidden: 'Hidden',
};

const cleanedName = (name) => {
  return name.replace(/[^a-zA-Z0-9&()+-]/g, '').toLowerCase();
};

export default {
  namespaced: true,
  state: {
    mapping: SMART_VALUES,
    categories: CATEGORIES,
    options: OPTIONS,
  },
  getters: {
    loading: (state, getters, rootState, rootGetters) => {
      const deviceTypesLoading = rootGetters['devicetypes/loading'];
      const manufacturersLoading = rootGetters['manufacturers/loading'];
      const devicesLoading = rootGetters['devices/loading'];
      const templateTypesLoading = rootGetters['templatetypes/loading'];
      const templatesLoading = rootGetters['templates/loading'];
      return !!(
        deviceTypesLoading ||
        manufacturersLoading ||
        devicesLoading ||
        templatesLoading ||
        templateTypesLoading
      );
    },

    getSmartValues: (state, getters, rootState, rootGetters) => {
      const deviceTypesLoading = rootGetters['devicetypes/loading'];
      if (deviceTypesLoading) return null;
      const deviceTypes = rootGetters['devicetypes/getDeviceTypes'];
      const deviceTypesIndex = {};
      deviceTypes.forEach((type) => {
        deviceTypesIndex[type.codename] = type.name;
      });
      return {
        DEVICETYPE: deviceTypesIndex,
        ...state.mapping,
      };
    },

    deviceIdByFilename: (state, getters, rootState, rootGetters) => (
      filename,
    ) => {
      const deviceTypes = rootGetters['devicetypes/getDeviceTypes'];
      const manufacturers = rootGetters['manufacturers/getManufacturers'];
      const devices = rootGetters['devices/getDevices'];

      const name = filename.toLowerCase().split('.svg')[0];
      const [devicetype, manufacturer, devicename] = name.split('_');

      const deviceTypeMatch = deviceTypes.find(
        (type) => type.codename.toLowerCase() === devicetype,
      );

      const manufacturerMatch = manufacturers.find((man) => {
        return (
          cleanedName(man.name).toLowerCase() === cleanedName(manufacturer)
        );
      });

      const selectedDevice = devices.find((device) => {
        // If a type ID was detected, check that it matches
        if (deviceTypeMatch && device.type_id !== deviceTypeMatch.id) {
          return false;
        }
        // If a manufacturer ID was detected, check that it matches
        if (
          manufacturerMatch &&
          device.manufacturer_id !== manufacturerMatch.id
        ) {
          return false;
        }
        // Device name should be a close match
        return cleanedName(device.name) === cleanedName(devicename);
      });
      if (selectedDevice) {
        return selectedDevice.id;
      }
      return null;
    },

    templateTypeByFilename: (state, getters, rootState, rootGetters) => (
      filename,
    ) => {
      const [, , , type] = filename.toLowerCase().split('_');
      const templateTypes = rootGetters['templatetypes/getTemplateTypes'];

      const selectedByCodename = templateTypes.find(
        (t) => t.codename.toLowerCase() === type.toLowerCase(),
      );
      if (selectedByCodename) {
        return selectedByCodename;
      }
      const selectedByName = templateTypes.find(
        (t) => t.name.toLowerCase() === type.toLowerCase(),
      );

      if (selectedByName) {
        return selectedByName;
      }

      return null;
    },
    templateTypeIdByFilename: (state, getters) => (filename) => {
      const templateType = getters.templateTypeByFilename(filename);
      if (templateType) {
        return templateType.id;
      }
      return null;
    },
    templateTypeNameByFilename: (state, getters) => (filename) => {
      const templateType = getters.templateTypeByFilename(filename);
      if (templateType) {
        return templateType.name;
      }
      return null;
    },

    categoriesByFilename: () => (filename) => {
      const [, , , , category] = filename.toLowerCase().split('_');
      const categories = category.split(',');
      const categoryMap = {
        typenormal: categories.includes('no'),
        typemagic: categories.includes('ma'),
        typeair: categories.includes('ai'),
        typebody: categories.includes('bo'),
      };
      return categoryMap;
    },

    optionsByFilename: () => (filename) => {
      const [, , , , , options] = filename.toLowerCase().split('_');
      const optionMap = {
        easyinstall: options.includes('ei'),
        cutonly: options.includes('co'),
        hidden: options.includes('h'),
      };
      return optionMap;
    },

    getPossibleDuplicates: (state, getters, rootState, rootGetters) => (
      filename,
    ) => {
      const deviceId = getters.deviceIdByFilename(filename);
      const templateTypeId = getters.templateTypeIdByFilename(filename);
      const matches = rootGetters['templates/getTemplates']
        .filter(
          (template) =>
            template.device_id === deviceId &&
            template.type_id === templateTypeId,
        )
        .map((template) => template.id);
      return matches;
    },
    getPossibleDuplicatesDetails: (state, getters, rootState, rootGetters) => (
      id,
      deviceId,
      typeId,
    ) => {
      const matches = rootGetters['templates/getTemplates']
        .filter(
          (template) =>
            template.device_id === deviceId &&
            template.type_id === typeId &&
            template.id !== id,
        )
        .map((template) => template.id);
      return matches;
    },
  },
  actions: {
    async ensure({ dispatch }) {
      dispatch('fetch');
    },
    async fetch({ dispatch }) {
      dispatch('templates/ensure', null, { root: true });
      dispatch('templatetypes/ensure', null, { root: true });
      dispatch('devices/ensure', null, { root: true });
      dispatch('devicetypes/ensure', null, { root: true });
      dispatch('manufacturers/ensure', null, { root: true });
    },
  },
};
